import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';

import { filterMethod, handleClose } from '../../Helpers/helpers';

import { ticketTypoTitle } from '../shared/commonStyle';

import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Button,
  Autocomplete,
  Typography,
  TextField,
  Modal,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@mui/material';

function InstallReportCabinetDetails(props) {
  const updateCabRow = props.updateCabRow;
  const customerName = props.customerName;
  const removeCabRow = props.removeCabRow;
  // const getMyRowData = props.getMyRowData;
  const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState();

  // const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState(
  //   []
  // );

  const [cabinetsList, setCabinetsList] = useState([]);
  // const [serialList, setSerialsList] = useState([]);
  const [openCabModal, setOpenCabModal] = useState(false);
  const handleOpenCabModal = () => setOpenCabModal(true);
  const handleCloseCabModal = () => setOpenCabModal(false);

  // const [openCabinet, setOpenCabinet] = useState({});
  const [openCabType, setOpenCabType] = useState({});
  const [openSerial, setOpenSerial] = useState({});
  const [openTemprature, setOpenTemprature] = useState('');
  const [openSnCheck, setOpenSnCheck] = useState('');
  const [openId, setOpenId] = useState('');

  const handleCabinet = (data) => {
    setOpenId(data.rowId);
    setOpenCabType({ id: data.cabId, name: data.cabType });
    setOpenSerial({ id: data.serialId, name: data.serialNo });
    setOpenTemprature(data.temprature);
    setOpenSnCheck(data.snCheck);
    handleOpenCabModal();
  };

  const cabData = props.rowsData;
  let rowsData = props.rowsData;
  // const [rowsData, setRowsData] = useState([]);

  // useEffect(() => {
  //   let outData = [];
  //   outData = cabData.map((cab, key) => ({ ...cab, rowId: key }));

  //   setRowsData(outData);
  // }, [cabData]);

  let onBlurEventsCapture = props.onBlurEventsCapture;

  useEffect(() => {
    serialsByCustomer(customerName, openCabType.cabId).then((data) => {
      mapAvailableCabinetTypes(data.data.value);
      mapAvailableSerials(data.data.value);
    });
  }, [customerName, openCabType]);

  // useEffect(() => {
  //   serialsByCustomer(customerName, openCabType.cabId).then((data) => {
  //     console.log(data.data.value);
  //     setSerialsList(data.data.value);
  //   });
  // }, [customerName, openCabType]);

  async function mapAvailableCabinetTypes(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => ({
      id: obj.cabinet_type_id,
      name: obj.cabinet_name,
    }));
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }

    setCabinetsList(distinctCabinetTypes);
  }

  const handleListChange = (event, newValue) => {
    const eventTarget = event.target.parentNode.id.split('-').shift();
    let eventValue = newValue;
    setAutocompleteValue(eventTarget, eventValue);
  };

  const handleInput = (event) => {
    switch (event.target.id) {
      case 'temprature':
        setOpenTemprature(event.target.value);
        break;
      case 'snChecked_yes':
        setOpenSnCheck(event.target.value);
        break;
      case 'snChecked_no':
        setOpenSnCheck(event.target.value);
        break;
      case 'snChecked_na':
        setOpenSnCheck(event.target.value);
        break;
      default:
        break;
    }
  };

  // const handleCabRemove = (data) => {
  //   removeCabRow(data);
  // };

  const setAutocompleteValue = (event, newValue) => {
    switch (event) {
      case 'cabinetType':
        // let value = [];

        setOpenCabType(newValue);
        setOpenSerial({});
        break;
      case 'serialNumber':
        setOpenSerial(newValue);
        break;
      default:
        break;
    }
  };
  // const combineData = () => {
  //   let blob = {
  //     id: openId,
  //     cabId: openCabType.id,
  //     cabType: openCabType.name,
  //     serialId: openSerial.id,
  //     serialNo: openSerial.name,
  //     temprature: openTemprature,
  //     snCheck: openSnCheck,
  //   };
  //   return blob;
  // };

  const cabinetUpdate = () => {
    const DataBlob = {
      rowId: openId,
      id: openId,
      cabId: openCabType.id,
      cabType: openCabType.name,
      serialId: openSerial.id,
      serialNo: openSerial.name,
      temprature: openTemprature,
      snCheck: openSnCheck,
    };
    updateCabRow(DataBlob);
    handleCloseCabModal();
  };

  // useEffect(() => {
  //   serialsByCustomer(location.state.customer_name).then((data) => {
  //     mapAvailableSerials(data.data.value);
  //   });
  // }, [location.state]);

  async function mapAvailableSerials(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => {
      return {
        id: obj.id,
        name: obj.serial_number,
      };
    });
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }
    setFilteredSerialNumbersList(distinctCabinetTypes);
  }

  return (
    <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
      <TableContainer>
        <Table
          sx={{ minWidth: 650, border: 1 }}
          size='small'
          aria-label='a dense table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                id='cabinetTypeHead'
                key='cabinetTypeHead'
                name='cabinetTypeHead'
                // onClick={handleClick}
                sx={{ borderBottom: 1, fontWeight: '700' }}
                width='25%'
              >
                Cabinet Type
              </TableCell>
              <TableCell
                id='serialNoHead'
                key='serialNoHead'
                name='serialNoHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
                align='left'
              >
                Serial No
              </TableCell>
              <TableCell
                id='descriptionHead'
                key='descriptionHead'
                name='descriptionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
                align='left'
              >
                Temperature
              </TableCell>
              <TableCell
                // className='d-print-none'
                id='actionHead'
                key='actionHead'
                name='actionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
                align='left'
              >
                SN Check
              </TableCell>
              {/* <TableCell
                id='action'
                key='action'
                name='action'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                align='left'
              >
                Action
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.map((row) => (
              <TableRow
                key={row.rowId}
                name={row.rowId}
                id={row.rowId}
                sx={{
                  '&:last-child td, &:last-child th': { borderBottom: 0 },
                }}
              >
                {/* {console.log(row)} */}
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='cabinetType'
                  key='cabinetType'
                  name='cabinetType'
                  defaultValue={row.cabType}
                  // onBlurCapture={(event) => {
                  //   onBlurEventsCapture(event, row);
                  // }}
                  cabinetType
                  sx={{
                    borderBottom: 1,
                    background:
                      row.temprature === undefined ||
                      row.snCheck === undefined ||
                      row.temprature === '' ||
                      row.snCheck === '' ||
                      row.temprature === null ||
                      row.snCheck === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  component='th'
                  scope='row'
                >
                  {row.cabType}
                </TableCell>
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='serialNo'
                  key='serialNo'
                  name='serialNo'
                  // onClick={() => onBlurEventsCapture(row)}
                  // defaultValue={row.serialNo}
                  // onBlurCapture={onBlurEventsCapture}
                  // onBlurCapture={(event) => {
                  //   onBlurEventsCapture(event, row);
                  // }}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.temprature === undefined ||
                      row.snCheck === undefined ||
                      row.temprature === '' ||
                      row.snCheck === '' ||
                      row.temprature === null ||
                      row.snCheck === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.serialNo}
                </TableCell>
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='temp'
                  key='temp'
                  name='temp'
                  // defaultValue=
                  // onClick={() => onBlurEventsCapture(row)}
                  // onBlurCapture={(event) => {
                  // onBlurEventsCapture(event, row);
                  //   console.log(event.target.id, row);
                  // }}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.temprature === undefined ||
                      row.snCheck === undefined ||
                      row.temprature === '' ||
                      row.snCheck === '' ||
                      row.temprature === null ||
                      row.snCheck === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.temprature || ''}
                </TableCell>

                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='temp'
                  key='temp'
                  name='temp'
                  // defaultValue=
                  // onClick={() => onBlurEventsCapture(row)}
                  // onBlurCapture={(event) => {
                  // onBlurEventsCapture(event, row);
                  //   console.log(event.target.id, row);
                  // }}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.temprature === undefined ||
                      row.snCheck === undefined ||
                      row.temprature === '' ||
                      row.snCheck === '' ||
                      row.temprature === null ||
                      row.snCheck === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.snCheck || ''}
                </TableCell>
                {/* <TableCell>
                  <Button
                    variant='contained'
                    size='small'
                    onClick={() => {
                      // handleOpen();
                      // getMyRowData(props.row);
                      console.log('PROPS ROW', row);
                    }}
                  >
                    Edit
                  </Button>
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        id='cabinetsModal'
        open={openCabModal}
        onClose={handleCloseCabModal}
        aria-labelledby='modal-cabinets'
        aria-describedby='modal-modal-cabinets'
      >
        <Box sx={style}>
          <Grid
            container
            xs={12}
            md={12}
            flexDirection='row'
            rowGap={1}
            // columnGap={1}
            alignContent='flex-start'
          >
            <Grid
              container
              xs={11}
              md={11}
              flexDirection='row'
              rowGap={1}
              columnGap={1}
              alignContent='flex-start'
            >
              <Grid item md={4}>
                <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
              </Grid>
              <Grid item md={6}>
                <Typography
                  size='small'
                  name='temprature'
                  key='temprature'
                  id='temprature'
                  fullWidth
                >
                  {openCabType.name}
                </Typography>
              </Grid>
              <Grid item md={4}>
                <Typography style={ticketTypoTitle}>Serial Number:</Typography>
              </Grid>
              <Grid item md={6}>
                <Typography
                  size='small'
                  name='temprature'
                  key='temprature'
                  id='temprature'
                  fullWidth
                >
                  {openSerial.name}
                </Typography>
              </Grid>
              <Grid item md={4}>
                <Typography style={ticketTypoTitle}>Temperature:</Typography>
              </Grid>
              <Grid item md={6}>
                <TextField
                  value={openTemprature}
                  size='small'
                  type='number'
                  onChange={handleInput}
                  name='temprature'
                  key='temprature'
                  id='temprature'
                  fullWidth
                />
              </Grid>
              <Grid item md={4}>
                <Typography style={ticketTypoTitle}>SN Check:</Typography>
              </Grid>
              <Grid item md={6}>
                <FormControlLabel
                  value='Yes'
                  control={
                    <Radio
                      id='snChecked_yes'
                      checked={openSnCheck === 'Yes'}
                      onChange={handleInput}
                    />
                  }
                  label='Yes'
                  labelPlacement='bottom'
                />
                <FormControlLabel
                  value='No'
                  control={
                    <Radio
                      id='snChecked_no'
                      checked={openSnCheck === 'No'}
                      onChange={handleInput}
                    />
                  }
                  label='No'
                  labelPlacement='bottom'
                />
                <FormControlLabel
                  value='N/A'
                  control={
                    <Radio
                      id='snChecked_na'
                      checked={openSnCheck === 'N/A'}
                      onChange={handleInput}
                    />
                  }
                  label='N/A'
                  labelPlacement='bottom'
                />
              </Grid>
            </Grid>
          </Grid>

          <Button
            sx={{ margin: '20px 0 0 20px', float: 'right' }}
            variant='contained'
            type='submit'
            color='success'
            className='btn btn-primary'
            onClick={() => cabinetUpdate()}
          >
            Save
          </Button>
        </Box>
      </Modal>
    </Grid>
  );
}

// const [cabinetTypes ]

export default InstallReportCabinetDetails;

//STYLE
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

//FUNCTIONS
async function serialsByCustomer(customerName, cabinetType) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
          {
            field: 'cabinet_type_id',
            search: cabinetType,
            strict: true,
          },
        ],
      },
    },
  };
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
